export default "__VITE_ASSET__D1YQuXQB__"